import React, {useEffect, useRef, useState} from "react";

import PartRow from "./PartRow.js";

import { Box, Button, Column, Columns, Field, Modal, Pagination, Section, Title } from "@allxsmith/bestax-bulma";
import { usePartsData } from "../../hooks/usePartsData";
import {
  getDataFresh,
  getDepartmentsData, getNominalCodesData,
  getPartsData, getPaymentTypesData, getTrackingOptionsData,
  getVehicleMakeData, getVehicleModelData,
  getVehicleTypesData
} from "../../state/selectors";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "react-spinner-material";
import {
  createSetDataFreshAction,
  createSetPartsDataAction
} from "../../actions/dataActions";
import useSelect from "../../hooks/useSelect";
import {useReactToPrint} from "react-to-print";
import PrintParts from "./PrintParts";
import FilterHeading from "../Invoicing/FilterHeading";
import axios from "axios";
import {ToastContainer, toast} from "react-toastify";
import FilterBlankHeading from "../Invoicing/FilterBlankHeading";
import MultipleEditModal from "./MultipleEditModal";
import useInput from "../../hooks/useInput";
import SearchBar from "../Utils/SearchBar";
import ApprovalModal from "./ApprovalModal";
import {compareVat, formatXeroData, sendXeroData} from "../../utils";
import {expenseDueDate} from "../../utils";
import BlankDepartmentSelector from "../Utils/BlankDepartmentSelector";
import PaginationWrapper from "../Utils/PaginationWrapper";

function Part(props) {
  const componentRef = useRef();

  const handlePrint = useReactToPrint({contentRef:componentRef});

  const [modalOpen, setModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [page, setPage] = useState(1);
  const [selected, setSelected] = useState({});
  const [searchText, setSearchText] = useState("");
  const [currentSearch, setCurrentSearch] = useState("");
  const [filters, setFilters] = useState({});
  const [searchFresh, setSearchFresh] = useState(1);
  const [approvalModal, setApprovalModal] = useState(false);
  const [selectedPart, setSelectedPart] = useState();
  const [filteredParts, setFilteredParts] = useState({results: []});



  //const vehicle_types_loaded = useVehicleTypeData({});

  const getFilteredParts = () => {
    if(selectedPart && selectedPart.part_invoice_number && selectedPart.supplier && selectedPart.supplier.id){
      // let source;
      // let supplier = selectedPart.supplier;
      //let url = props.endpoint+"parts?supplier="+supplier.id+"&backorder=false";
      let url = props.endpoint+"parts?inv_num="+selectedPart.part_invoice_number+"&supplier="+selectedPart.supplier.id+"&page_size=1000";
      if(selectedPart.cost < 0){
        url = url+"&negative=true"
      }
      if(selectedPart.ready_to_approve){
          url = url+"&ready=true"
      }
      // if(selectedPart.job){
      //   source = selectedPart.job;
      //   url = url+"&job="+source.id;
      // }
      // else if(selectedPart.quote){
      //   source = selectedPart.quote
      //   url = url+"&quote="+source.id
      // }

      const conf = {
        url: url,
        method: "get"
      }
      axios(conf).then(res => {
        setFilteredParts(res.data);
      }).catch(err => {
        toast.error("An error occurred", {position: "top-right"});
      })
    }
  }

  useEffect(() => {
    getFilteredParts()
  }, [selectedPart]);

  const openApproveModal = part => {
    setSelectedPart(part);
    setApprovalModal(true);
  }

  const headings = [
    {
      label: 'ID'
    },
    {
      label: "Registration",
      field: "job__vehicle",
      labelField: "job__vehicle__registration",
      className: "small-typeahead"
    },
    { label: "Make/Model" },
    {
      label: "Part Supplier",
      field: "supplier",
      labelField: "supplier__display_name"
    },
    {
      label: "Part Name",
      blank: true,
      field: "name"
    },
    {
      label: "Part Number",
      blank: true,
      field: "part_number",
      className: "small-column"
    },
    {
      label: "Cost",
      blank: true,
      field: "cost",
      className: "small-typeahead",
      thClass: "small-column"
    },
    {
      label: "VAT",
      className: "small-column",
      thClass: "small-column"
    },
    {
      label: "Tracking Category"
    },
    {
      label: "Workshop Date",
      field: "job__workshop_date",
      labelField: "job__workshop_date",
      date: true
    },
    {
      label: "Date Ordered",
      field: "date_ordered",
      labelField: "date_ordered",
      date: true
    },
    {
      label: "Payment Type",
      field: "payment_type",
      labelField: "payment_type__name",
      className: "small-column"
    },
    {
      label: "Nominal Code"
    },
    {
      label: "Invoice Number",
      blank: true,
      field: "part_invoice_number"
    },
    {
      label: "Invoice Date"
    },
    {
      label: "Comments"
    },
    { label: "Stock Accrual" },
    { label: "Stock Amount"},
    { label: "Backorder Date"},
    { label: "Stock Kept At Workshop"},
    { label: "Part Arrived"}
  ];

  const [startDate, startDateInput, setStartDate] = useInput({
    type:"date",
    label:"Start Date",
  });

  const [endDate, endDateInput, setEndDate] = useInput({
    type:"date",
    label:"End Date",
  });

  const [dueDateStart, dueDateStartInput, setDueDateStart] = useInput({
    type:"date",
    label:"Due Date From",
  });

  const [dueDateEnd, dueDateEndInput, setDueDateEnd] = useInput({
    type:"date",
    label:"Due Date To"
  });

  let params = { page };

  for (let filter in filters) {
    if (filters[filter][0] && filters[filter][0][filter]) {
      params[filter] = filters[filter][0][filter];
    }
  }

  const onSelectCheck = item => {
    let newSelection = { ...selected };
    if (Object.keys(selected).indexOf(item.id.toString()) === -1) {
      newSelection[item.id.toString()] = item;
    } else {
      delete newSelection[item.id.toString()];
    }
    setSelected(newSelection);
  };

  const dueDateFilter = (part) => {
    let dueDate = expenseDueDate(part, "invoice_date", "supplier");
    let filterStart = new Date(dueDateStart);
    let filterEnd = new Date(dueDateEnd);
    if(dueDate >= filterStart && dueDate <= filterEnd){
      return true
    }
    return false
  }

  const selectDueDateFilter = () => {
    if(dueDateStart && dueDateEnd) {
      let newSelected = { ...selected };
      let filteredItems = data.results.filter((part) => dueDateFilter(part));
      filteredItems.forEach(item => {
        newSelected[item.id.toString()] = item;
      });

      setSelected(newSelected);
    } else {
      toast.warning("Please enter due date start and end", {position: "top-right"})
    }
  }


  const clearSelected = () => {
    setSelected({});
  };

  const [view, viewInput] = useSelect({
    label: "View",
    options: [
      { name: "Current", value: "current" },
      { name: "To Be Ordered", value: "to_order" },
      { name: "Ready to Approve", value: "ready_to_approve"},
      { name: "Approved", value: "approved" },
      { name: "Stock", value: "stock" },
      { name: "Stock Ordered", value: "stock_ordered"},
      { name: "Backorder", value: "backorder"}
    ],
    initialValue: "current",
    testId: "part-view",
    callback: () => {
      setPage(1);
    }
  });

  const [showInvoiceNumbers, showInvoiceNumbersInput] = useSelect({
    label: "Show Only Invoice Numbers",
    options: [
      {name: "Yes", value: "true"},
      {name: "No", value: "false"}
    ],
    initialValue: "false",
    callback: () => {
      setPage(1);
    }
  });

  let [selectedDepartment, setSelectedDepartment] = useState(-1);

  if (view) {
    params.view = view;
  }

  if(showInvoiceNumbers){
    params.invoice_number=showInvoiceNumbers;
  }

  if (selectedDepartment) {
    params.department = selectedDepartment;
  }

  if (currentSearch) {
    params.search = currentSearch;
  }
  if (searchFresh){
    params.searchFresh = searchFresh;
  }
  if(startDate && endDate){
    params.startDate = startDate;
    params.endDate = endDate;
  }
  const dispatch = useDispatch();
  const dataFresh = useSelector(getDataFresh);
  const complete = usePartsData(params, dataFresh);
  const data = useSelector(getPartsData);
  //const makesLoaded = useVehicleMakeData({page_size:1000}, dataFresh);
  //const modelsLoaded = useVehicleModelData({page_size:1000}, dataFresh);
  const makes = useSelector(getVehicleMakeData);
  const models = useSelector(getVehicleModelData);
  //let departments_loading = useDepartmentsData({}, dataFresh);
  //const paymentTypesLoaded = usePaymentTypesData({}, dataFresh);
  const paymentTypes = useSelector(getPaymentTypesData);
  const departments = useSelector(getDepartmentsData);
  //const nominalCodesLoaded = useNominalCodesData({page_size: 1000}, dataFresh);
  const nominalCodes = useSelector(getNominalCodesData);
  //const trackingOptionsLoaded = useTrackingOptionsData({page_size: 1000}, dataFresh);
  const trackingOptions = useSelector(getTrackingOptionsData);
  const vehicle_types = useSelector(getVehicleTypesData);

  const onSave = (e, part) => {
      const url = props.endpoint + "parts/update/" + part.id;
      const conf = {
        method: "put",
        data: part,
        url
      };

      axios(conf).then(() => {
        dispatch(createSetDataFreshAction(dataFresh + 1));
      });
  };

  const onApproveModalClose = () => {
    setApprovalModal(false);
    setSelectedPart(null);
    setFilteredParts(null);
  }



  const validator = part => {
    if(!(!!part.supplier_nominal_code)){
      toast.warning("Nominal Code is required", {position: "top-right"})
      return false
    }
    if(!(compareVat(part.supplier_nominal_code, part.cost_vat))){
      // MOVE WHEN POST THROUGH AS APPROVED
      toast.warning("Vat entered does not match nominal vat", {position: "top-right"})
    }
    if(!part.supplier.partial_contact){
      if (part.part_invoice_number.length > 0 && part.part_invoice_number && part.invoice_date) {
        return true;
      } else {
        toast.warning(
          "You must specify an invoice number and Invoice date before approving!", {position: "top-right"});
        return false;
      }
    } else {
      toast.warning("The Supplier must be a complete contact", {position: "top-right"})
    }
  };

  const onReadyToInvoice = (data) => {
    let valid = true;
    data.forEach((part, index) => {
      // what is this doing? why are we assigning elements to an index they already exist in?
      if(validator(part)) {
        data[index] = part;
      }
      else{
        valid = false;
      }
    });
    if(valid){
        const conf = {
            url: props.endpoint+"parts/ready",
            method: "put",
            data
        }
        axios(conf).then(res=> {
            dispatch(createSetDataFreshAction(dataFresh + 1));
            onApproveModalClose();
        })
    }
  }

  const onNotReadyToInvoice = (data) => {
      const conf = {
          url: props.endpoint+"parts/notready",
          method: "put",
          data
      }
      axios(conf).then(res=> {
          dispatch(createSetDataFreshAction(dataFresh + 1));
          onApproveModalClose();
      })
  }

  const onApprove = (data) => {
    // Data should be an array of part objects
    // Validate parts for invoicing
    let valid = true;
    let newData = [...data]
    newData.forEach((part, index) => {
      if(validator(part)) {
        let newPart = {...part}
        newPart.approved = true;
        newData[index] = newPart;
      }
      else{
        valid = false;
      }
    });
    if(valid) {
      const conf = {
        url: props.endpoint + "parts/update",
        method: "put",
        data:  newData
      }
      axios(conf).then(res => {
        // Handle sending the data off to xero
        // DATA IS NOT ALWAYS A PURCHASE INVOICE
        // DATA CAN BE A CREDIT NOTE
        let invoice;
        let source;
        let target;
        if(selectedPart.cost > 0) {
          source = "PA"
          target = "PurchaseInvoice"
        }
        else if(selectedPart.cost < 0){
          source = "PAP"
          target = "PurchaseCreditNote" //PurchaseCreditNotes
        }
        invoice = formatXeroData(res.data, source);
        if(invoice.XeroDept) {
         sendXeroData(invoice, target).then(res => {
           toast.success("All data has been sent to xero", {position: "top-right"})
         }).catch(err => {
           toast.error("There was an error sending", {position: "top-right"})
         })
        }
        dispatch(createSetDataFreshAction(dataFresh + 1));
        onApproveModalClose();
      }).catch(err => {
        console.log(err);
        toast.error("There was an error approving parts", {position: "top-right"})
      })
    }
    else{
      toast.warning("Cannot approve parts", {position: "top-right"})
    }
  }

  const handleStateChange = (data, target) => {
      // target is the new State for all data

      // figure out if the data is being approved or ready to approved
      // make sure that all items in data are at the same point of the process
      let count = 0;
      let func;
      if(target === "ready"){
          count = data.filter(item => item.ready_to_approve === false);
          count = count.length;
          func = onReadyToInvoice;
      }
      else if(target === "approved"){
          count = data.filter(item => item.ready_to_approve === true).length;
          func = onApprove
      }
      if(count === data.length){
          // all the data is in the state before the target state
          // determine which function to call based on target
          func(data)
      }
      else {
          toast.error("Not all parts are in the same state", {position: "top-right"});
      }
  }


  const onPartUpdate = (index, newPart) => {
    let newResults = [...data.results]
    let newState = { ...data, results: newResults };
    newState.results[index] = newPart;
    dispatch(createSetPartsDataAction(newState));
    setSelected({});
  };

  const handleSearch = () => {
    setPage(1);
    setCurrentSearch(searchText);
    setSearchFresh(searchFresh+1);
  };

  const clear = () => {
    setSearchText("");
    setCurrentSearch("");
    setPage(1);
  };

  const updateMultiple = newData => {
    const url = props.endpoint + "parts/update";
    const conf = {
      method: "put",
      data: newData,
      url
    };

    return axios(conf).then(() => {
      dispatch(createSetDataFreshAction(dataFresh + 1));
      setSelected({});
    });
  };

  const saveSelected = (invoiceNumber, dateOrdered, supplier, invoiceDate, trackingOption, nominalCode, paymentType) => {
    const newData = Object.values(selected).map(item => {
      let toSave = { ...item };
      if (invoiceDate) {
        toSave.invoice_date = invoiceDate;
      }
      if (invoiceNumber) {
        toSave.part_invoice_number = invoiceNumber;
      }
      if (dateOrdered) {
        toSave.date_ordered = dateOrdered;
      }
      if(supplier) {
        toSave.supplier = supplier;
      }
      if(trackingOption){
        toSave.supplier_tracking_option = trackingOption
      }
      if(nominalCode){
        toSave.supplier_nominal_code = nominalCode
      }
      if(paymentType){
        toSave.payment_type = paymentType
      }
      return toSave;
    });
    return updateMultiple(newData);
  };

  const approveSelected = () => {
    let passValidation = true;
    const newData = Object.values(selected).map(item => {
      if (item.part_invoice_number.length > 0) {
        return { ...item, approved: true };
      } else {
        passValidation = false;
        return {};
      }
    });

    if (passValidation) {
      return updateMultiple(newData);
    } else {
      toast.warning(
        "You must specify an invoice number (numbers only)!", {position: "top-right"});
    }
  };
  const onDepartmentChange = (e) => {
    setSelectedDepartment(e.target.value);
  }
  const toggleSelectVisible = () => {
    let newSelected = { ...selected };
    let selectedKeys = Object.keys(newSelected);
    const notPresent = data.results.find(
      part => selectedKeys.indexOf(part.id.toString()) === -1
    );

    if (notPresent) {
      data.results.forEach(item => {
        newSelected[item.id.toString()] = item;
      });
    } else {
      data.results.forEach(item => {
        delete newSelected[item.id.toString()];
      });
    }
    setSelected(newSelected);
  };

  if (!complete || !props.loaded){//!vehicle_types_loaded || !departments_loading || !modelsLoaded || !makesLoaded || !paymentTypesLoaded || !nominalCodesLoaded || !trackingOptionsLoaded) {
    return (
      <div className="spinner-centre">
        <Spinner
          className="spinner-centre"
          radius={120}
          color={"#3273dc"}
          stroke={5}
        />
      </div>
    );
  }

  const codeObjects = nominalCodes.results.reduce((obj, item) => {
      return {
        ...obj,
        [item["id"]]: item
      };
  }, {});

  const trackingOptionObjects = trackingOptions.results.reduce((obj, item) => {
      return {
        ...obj,
        [item["id"]]: item
      };
  }, {});

  const paymentTypeObjects =  paymentTypes ? paymentTypes.results.reduce((obj, item) => {
    return {
      ...obj,
      [item["id"]]: item
    };
  }, {}) : {};

  const departmentObjects =  departments ? departments.results.reduce((obj, item) => {
    return {
      ...obj,
      [item["id"]]: item
    };
  }, {}) : {};

  document.title = `Part Expenses`;

  // TODO(bestax-migrate): Form.Label became a plain element; the Bulma helper prop(s) `invisible` were dropped — restyle with classes
  // TODO(bestax-migrate): `showFirstLast` — no showFirstLast prop in bestax Pagination
  // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
  return (
    <div>
      <br/>
      <br/>
      <Box>
        <h1 className="title">{(props.loaded && !!departmentObjects[selectedDepartment]) ? `Part Expenses - ${departmentObjects[selectedDepartment].name}` : `Part Expenses`}</h1>
        <Columns isMultiline>
          {viewInput}
          <Column>
              <BlankDepartmentSelector
                departments={departments}
                selectedDepartment={selectedDepartment}
                onDepartmentChange={onDepartmentChange}
              />
          </Column>
          <Column size={4}>
            <label className="label">Search</label>
            <SearchBar
              handleSearch={handleSearch}
              setSearchText={setSearchText}
              searchText={searchText}
              clear={clear}
            />
          </Column>
        </Columns>
        <Title size="6">Date Ordered Filter</Title>
        <Columns isMultiline>
          {startDateInput}
          {endDateInput}
          {showInvoiceNumbersInput}
          {dueDateStartInput}
          {dueDateEndInput}
          <Column>
            <label className="label">button</label>
            <Button
              color={"success"}
              onClick={() => selectDueDateFilter()}
            >
              Select Filtered Parts
            </Button>
          </Column>
        </Columns>
      </Box>
      <Box>
        Total Parts Cost: £
        {data.total_cost.toLocaleString(undefined, {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })}
      </Box>
      <Box>
        <table className="table is-hoverable is-fullwidth is-striped">
          <thead>
            <tr className="small-row-black">
              {headings.map(heading => {
                if (!heading.field) {
                  return <th key={heading.label} className={heading.className || ""}>{heading.label}</th>;
                }
                if (heading.blank) {
                  return (
                    <FilterBlankHeading
                      key={heading.label}
                      heading={heading}
                      setFilters={f => {
                        setPage(1);
                        setFilters(f);
                      }}
                      filters={filters}
                      className={heading.className}
                      thClass={heading.thClass}
                    />
                  );
                }
                return (
                  <FilterHeading
                    key={heading.label}
                    heading={heading}
                    setFilters={f => {
                      setPage(1);
                      setFilters(f);
                    }}
                    filters={filters}
                    options={data.filter_list[heading.field]}
                    className={heading.className}
                    thClass={heading.thClass}
                  />
                );
              })}
              {view === 'approved' && <th>Approver</th>}
              <th>
                <Button
                  onClick={toggleSelectVisible}
                  color={
                    data.results.find(
                      part =>
                        Object.keys(selected).indexOf(part.id.toString()) === -1
                    )
                      ? ""
                      : "danger"
                  }
                >
                  {data.results.find(
                    part =>
                      Object.keys(selected).indexOf(part.id.toString()) === -1
                  ) ? (
                    <div>
                      O
                      <span> Visible</span>
                    </div>
                  ) : (
                    <div>
                      X
                      <span> Visible</span>
                    </div>
                  )}
                </Button>
              </th>
              {!!Object.entries(selected).length && (
                <th>
                  <Button onClick={() => setSelected({})} color="danger">
                    X
                  </Button>
                </th>
              )}
            </tr>
          </thead>
          <tbody>
            {data.results.map((value, index) => (
              <PartRow
                key={value.id}
                part={value}
                index={index}
                onPartUpdate={onPartUpdate}
                endpoint={props.endpoint}
                showApprove={view === "current" || view === "ready_to_approve"}
                onSelectCheck={onSelectCheck}
                selected={
                  Object.keys(selected).indexOf(value.id.toString()) !== -1
                }
                clearSelected={clearSelected}
                vehicleTypes={vehicle_types.results}
                approvedView={view === 'approved'}
                makes={makes}
                models={models}
                paymentTypes={paymentTypes}
                codeObjects={codeObjects}
                nominalCodes={nominalCodes}
                onApprove={openApproveModal}
                trackingOptions={trackingOptions}
                trackingOptionObjects={trackingOptionObjects}
                onNotReadyToInvoice={onNotReadyToInvoice}
              />
            ))}
          </tbody>
        </table>
          <div className={"second-delete"}>
          <Button
                  onClick={toggleSelectVisible}
                  color={
                    data.results.find(
                      part =>
                        Object.keys(selected).indexOf(part.id.toString()) === -1
                    )
                      ? ""
                      : "danger"
                  }
                  className={"second-delete-button"}
                >
                  {data.results.find(
                    part =>
                      Object.keys(selected).indexOf(part.id.toString()) === -1
                  ) ? (
                    <div>
                      O
                      <span> Visible</span>
                    </div>
                  ) : (
                    <div>
                      X
                      <span> Visible</span>
                    </div>
                  )}
                </Button>
            </div>
        <PaginationWrapper
          setPage={setPage}
          page={page}
          dataCount={Math.ceil(data.count / 25)}
        />
      </Box>
      <Box>
        <Columns isMultiline>
          <Column>
            <Button
              onClick={() => setEditModalOpen(true)}
              color={Object.entries(selected).length ? "primary" : ""}
              disabled={!Object.entries(selected).length}
              isFullWidth
            >
              Edit Selected
            </Button>
          </Column>
          <Column>
            <Button
              onClick={() => setModalOpen(true)}
              color={Object.entries(selected).length ? "warning" : ""}
              disabled={!Object.entries(selected).length}
              isFullWidth
            >
              Print Selected
            </Button>
          </Column>
          {(view === "current" || view === "stock") && false && (
            <Column>
              <Button
                onClick={() => approveSelected()}
                color={Object.entries(selected).length ? "success" : ""}
                disabled={!Object.entries(selected).length}
                isFullWidth
              >
                Approve Selected
              </Button>
            </Column>
          )}
        </Columns>
      </Box>
      <Modal closeOnBlur active={modalOpen} onClose={() => setModalOpen(false)}>
        <Modal.Content>
          <Section style={{ backgroundColor: "white" }}>
            <Field>
              <p>
                You have selected {Object.keys(selected).length} out of total of{" "}
                {data.count} items for printing
              </p>
            </Field>
              <Button
                color={Object.entries(selected).length ? "success" : ""}
                onClick={handlePrint}
              >
                Print Selected
              </Button>
          </Section>
        </Modal.Content>
      </Modal>
      <MultipleEditModal
        open={editModalOpen}
        setOpen={setEditModalOpen}
        selected={selected}
        saveSelected={saveSelected}
        trackingOptions={trackingOptions}
        trackingObjects={trackingOptionObjects}
        nominalCodes={nominalCodes}
        codeObjects={codeObjects}
        paymentTypes={paymentTypes}
        paymentTypeObjects={paymentTypeObjects}
      />
      {selectedPart && filteredParts &&
        <ApprovalModal
          data={filteredParts}
          show={approvalModal}
          setShow={setApprovalModal}
          nominalCodes={nominalCodes}
          paymentTypes={paymentTypes}
          codeObjects={codeObjects}
          paymentObjects={paymentTypeObjects}
          onSave={onSave}
          onCancel={onApproveModalClose}
          onStateChange={handleStateChange}
          trackingOptions={trackingOptions}
          trackingOptionObjects={trackingOptionObjects}
          view={view}
        />
      }
      <div style={{ display: "none" }}>
        <PrintParts data={selected} ref={componentRef} />
      </div>
    </div>
  );
}

export default Part;
